import React from 'react'
import { Modal, ModalBody, ModalTitle,ModalFooter } from '@vds/modals';
import { Body } from '@vds/typography';
import { MarginSpacerS } from '../../Pages/Checkout/styleTag';

export const SupportModal=({opened=false,onOpenedChange=()=>{}})=>{
    return(
    <Modal disableOutsideClick={true} disableFocusLock= {true}  opened={opened} onOpenedChange={onOpenedChange} id="support-modal">
        <ModalTitle>Please call the Fios Business Sales and Billing Center(1-844-230-0411) </ModalTitle>
        <ModalBody> 
            <Body size="medium">Hours of Operation(EST)</Body>
            <MarginSpacerS/>
            <Body size="medium">Monday to Friday - 8:30 am to 6 pm</Body>
            <MarginSpacerS/>
            <Body size="medium">Saturday - Closed</Body>
            <MarginSpacerS/>
            <Body size="medium">Sunday - Closed</Body>
        </ModalBody>
    </Modal>
    )
}